import React, { createContext, useState, useContext, useEffect } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  // Inicializace košíku z localStorage, aby data nezmizela při refreshu stránky
  const [cartItems, setCartItems] = useState(() => {
    const savedCart = localStorage.getItem('rezbarstvi_cart');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  // Uložení do localStorage při každé změně košíku
  useEffect(() => {
    localStorage.setItem('rezbarstvi_cart', JSON.stringify(cartItems));
  }, [cartItems]);

  // Přidání do košíku
  const addToCart = (product) => {
    setCartItems((prev) => [...prev, product]);
  };

  // Smazání jedné položky podle indexu
  const removeFromCart = (indexToRemove) => {
    setCartItems((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  // Vyčištění celého košíku (po nákupu)
  const clearCart = () => {
    setCartItems([]);
  };

  const cartCount = cartItems.length;
  const totalPrice = cartItems.reduce((sum, item) => sum + item.price, 0);

  return (
    <CartContext.Provider value={{ 
      cartItems, 
      addToCart, 
      removeFromCart, 
      clearCart, 
      cartCount, 
      totalPrice 
    }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart musí být použit uvnitř CartProvideru');
  }
  return context;
};